import React, { useEffect, useState } from "react";
import ContentHeading from "../../../../components/layout/content/ContentHeading";
import InputTextField from "../../../../components/input/inputTextField";
import TableCustom from "../../../../components/table/tableCustom";
import TableRowCommon from "../../../../components/table/TableRowCommon";
import { useDispatch } from "react-redux";
import { NavigateFunction, useNavigate } from "react-router-dom";
import { RemoveRedEyeOutlined, SearchOutlined } from "@mui/icons-material";
import { debouncedApiCall } from "../../../../utils/app.utils";
import { CourseAnnualDetailAPI } from "../../../../api/course-annual-detail/course-annual-detail.api";
import FilterSelect from "../../../../components/select/filterSelect";
import { MenuItem } from "@mui/material";
import { generateYearRange, generateYearRangeAgo } from "../../../../utils/date.utils";
import { routeName } from "../../../../routes/routeName";
import { AcademicYearApi } from "../../../../api/academic-year/academic-year.api";
import { useTranslation } from "react-i18next";

type Props = {};

const SubjectTaught: React.FC<Props> = (props: Props) => {
  const { t } = useTranslation();
  const navigate: NavigateFunction = useNavigate();
  const dispatch = useDispatch();

  const [data, setData] = useState<any[]>([]);

  const [search, setSearch] = useState<string>("");
  const [year, setYear] = useState<string>("");
  const [term, setTerm] = useState<string>("");
  const [dataYear, setDataYear] = useState<any>([]);

  const [page, setPage] = useState<number>(1);
  const [pageLimit, setPageLimit] = useState<number>(10);
  const [totalItems, setTotalItems] = useState<number>(0);
  const [sortBy, setSortBy] = useState<string>("");
  const [sortType, setSortType] = useState<string>("ASC");
  const handleRequestSort = (sortBy: string, sortType: string) => {
    setSortBy(sortBy);
    setSortType(sortType);
  };

  const getData = async () => {
    let query: any = {
      page: page,
      limit: pageLimit,
      sortBy: sortBy,
      sortType: sortType,
      year: year ?? "",
      term: term ?? "",
    };

    if (search) query = { ...query, search: search };

    const res = await CourseAnnualDetailAPI.getCourseAnnualDetailList(query);
    const data = res.data;
    if (data.status < 300) {
      setData(res.data?.data?.items ?? []);
      setTotalItems(res.data?.data?.meta?.totalItems || 0);
    } else {
      setData([]);
    }
  };

  const headCells = [
    {
      id: "advisor_file",
      width: 100,
      sortable: false,
      disablePadding: false,
      align: "start",
      label: t("ปีการศึกษา"),
    },
    {
      id: "status",
      disablePadding: false,
      width: 500,
      sortable: false,
      align: "start",
      label: t("ภาคเรียนที่"),
    },
    {
      id: "action",
      disablePadding: false,
      width: 50,
      sortable: false,
      align: "center",
      label: "",
    },
  ];

  const renderData = (objData: any, no: any) => {
    no = page * pageLimit - pageLimit + no + 1;
    const {
      id_course_of_study,
      academic_year,
      semester,
      course_of_study_start_date,
      course_of_study_end_date,
    } = objData;

    const objRenderData = {
      key: id_course_of_study,
      id: no,
      obj: objData,
      columns: [
        {
          option: "TEXT",
          align: "start",
          label: academic_year,
        },
        {
          option: "TEXT",
          align: "start",
          label: semester,
        },
        {
          option: "TEXT",
          align: "center",
          label: (
            <>
              <RemoveRedEyeOutlined
                onClick={() => {
                  navigate(
                    routeName.advisor.SubjectTaught + `/${id_course_of_study}/course-annual?year=${academic_year}&term=${semester}`
                  );
                }}
                style={{
                  cursor: "pointer",
                }}
              />
            </>
          ),
        },
      ],
    };
    return <TableRowCommon {...objRenderData} />;
  };

  useEffect(() => {
    getData();
  }, [page, pageLimit, sortBy, sortType, search, year, term]);

   const getAcademicYearList = async () => {
          let query: any = {
              page: 1,
              limit: 1000,
          }
          await AcademicYearApi.getAcademicYearListActive(query).then((res) => {
              if (res.status < 300) {
                  setDataYear(res.data?.data.items.map((x: any) => { return { ...x, year: x?.academic_year } }) || []);
              }
          }).catch((err) => {
              console.log(err)
          })
      }
  useEffect(() => {
    // const currentYear = new Date().getFullYear() + 543;
    // const data = generateYearRangeAgo(currentYear, 10);

    // setDataYear(data ?? []);
    getAcademicYearList()
  }, []);

  return (
    <div>
      <ContentHeading
        title={t("รายวิชาที่สอน")}
        detail={t("กรุณาเลือกรายการที่ท่านต้องการ")}
      />

      <div className="w-full grid grid-cols-12 gap-4 mt-[40px]">
        <article className="w-full col-span-12 lg:col-span-3  md:col-span-3  sm:col-span-3">
          <FilterSelect
            value={year ?? ""}
            labelId="academic-year-id"
            selectId="academic-year-select-id"
            options={[
              {
                value: "",
                label: t("ทุกปีการศึกษา"),
              },
              ...dataYear.map((item: any) => ({
                value: item?.year,
                label: item?.year,
              })),
            ].map((item, index) => (
              <MenuItem value={item.value} key={index}>
                {item.label}
              </MenuItem>
            ))}
            onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setYear(e.target.value)
            }
          />
        </article>

        <article className="w-full col-span-12 lg:col-span-3  md:col-span-3  sm:col-span-3">
          <FilterSelect
            value={term ?? ""}
            labelId="term-id"
            selectId="term-select-id"
            options={[
              {
                value: "",
                label: t("ทุกภาคเรียน"),
              },
              {
                value: "1",
                label: "1",
              },
              {
                value: "2",
                label: "2",
              },
              {
                value: "3",
                label: "3",
              },
              // {
              //   value: "4",
              //   label: "4",
              // },
            ].map((item, index) => (
              <MenuItem value={item.value} key={index}>
                {item.label}
              </MenuItem>
            ))}
            onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setTerm(e.target.value)
            }
          />
        </article>
      </div>

      <section className="w-full mt-10">
        <TableCustom
          tableMinWidth={600}
          tableFixedWidth
          customScroll
          page={page}
          pageLimit={pageLimit}
          sortBy={sortBy}
          sortType={sortType}
          headCells={headCells}
          rowCount={totalItems}
          rowsData={
            data &&
            data.map((data: any, i: any) => {
              return renderData(data, i);
            })
          }
          onSort={handleRequestSort}
          setPageLimit={(value: number) => setPageLimit(value)}
          setPage={(value: number) => setPage(value)}
        />
      </section>
    </div>
  );
};

export default SubjectTaught;
